import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import {
  InstantWins,
  TicketCardStyle,
  TicketCardType
} from '@core/models/raffle.model';
import { GbpCurrencyPipe } from '@custom-pipes/index';

@Component({
  selector: 'app-ticket-card',
  templateUrl: './ticket-card.component.html',
  styleUrls: ['./ticket-card.component.scss'],
  standalone: true,
  imports: [CommonModule, GbpCurrencyPipe]
})
export class TicketCardComponent implements OnChanges {
  @Input() ticket: InstantWins = null;
  @Input() isAnimated = false;
  @Input() ticketStyle: TicketCardStyle = TicketCardStyle.Default;
  @Input() ticketSize = '';
  @Input() autoReveal = false;
  @Input() showTicketNumber = true;

  ticketCardType = TicketCardType;
  ticketCardStyle = TicketCardStyle;

  paddedTicketNumber = '';

  ngOnChanges() {
    if (this.ticket) {
      this.paddedTicketNumber = this.ticket.ticket_number.padStart(6, '0');
    }
  }
}
